<p-dialog [(visible)]="visible" [modal]="true" [dismissableMask]="false"
    [styleClass]="data.isSuccess ? 'success-container' : 'error-container'" (onHide)="close()" [draggable]="false">
    <ng-template pTemplate="header">
        <div class="modal-header">
            <h2>{{ data.title || (data.isSuccess ? "Create RCA" : "Error") }}</h2>
        </div>
    </ng-template>

    <div class="modal-body">
        <div class="check-icon-image">
            <img [src]="
          data.isSuccess ? 'assets/icons/check.svg' : 'assets/icons/warning.svg'
        " alt="Popup Icon" class="circle-img" width="48" height="48" />
        </div>

        <p class="success-msg" [ngClass]="{ 'error-msg': !data.isSuccess }">
            {{ data.message }}
        </p>
    </div>
</p-dialog>